export { default } from './AppContainer';



// WEBPACK FOOTER //
// src/App/index.js